import React, { useState } from "react";
import { resolveIconUrl } from "../../utils/iconUrl";
import { WR } from "./tokens";

/**
 * Backend icon (over-category / category / product) with robust URL
 * resolution + a graceful monogram fallback. If the image URL is missing or
 * fails to load, render the first letter of `label` instead of a broken tile
 * (mirrors the mobile app's resilience). Caller picks which raw value to pass
 * (e.g. icon, dark_icon, or `dark_icon ?? icon`).
 */
const SmartIcon = ({ src, label = "", size = 30, style }) => {
  const [failed, setFailed] = useState(false);
  const url = resolveIconUrl(src);

  if (!url || failed) {
    return (
      <span
        aria-hidden="true"
        style={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          width: size,
          height: size,
          borderRadius: 8,
          background: WR.color.lavSoft,
          color: WR.color.brand,
          fontWeight: 800,
          fontSize: Math.max(10, Math.round(size * 0.42)),
          flexShrink: 0,
          ...style,
        }}
      >
        {(label || "?").trim().charAt(0).toUpperCase()}
      </span>
    );
  }

  return (
    <img
      src={url}
      alt={label}
      onError={() => setFailed(true)}
      style={{ width: size, height: size, objectFit: "contain", flexShrink: 0, ...style }}
    />
  );
};

export default SmartIcon;
